import { Outlet, RouteObject } from 'react-router-dom';
import { loadable } from '@sib/ui';
import { paths } from '@sidecar/config/paths';

export const routes: RouteObject[] = [
  {
    path: paths.organizations.root,
    element: loadable(() => import('./pages/OrganizationsPage')),
  },
  {
    path: paths.organizations.details.documentsPreview,
    element: loadable(() => import('./pages/OrganizationDocumentPreviewPage')),
  },
  {
    path: paths.organizations.details.documentsViewer,
    element: loadable(() => import('./pages/OrganizationDocumentViewerPage')),
  },
  {
    path: paths.organizations.details.root,
    element: loadable(() => import('./pages/OrganizationDetailsPage')),
    children: [
      {
        path: paths.organizations.details.tab,
        element: <Outlet />,
        children: [
          {
            path: paths.organizations.details.vendorsTab.children.details,
            element: <Outlet />,
          },
          {
            path: 'tickets',
            element: <Outlet />,
            children: [
              { path: 'new', element: <Outlet /> },
              {
                path: ':ticketId',
                element: <Outlet />,
                children: [
                  { path: 'edit', element: <Outlet /> },
                  { path: 'comments', element: <Outlet /> },
                  { path: 'comments/new', element: <Outlet /> },
                  { path: 'related-tasks', element: <Outlet /> },
                  { path: 'related-tasks/new', element: <Outlet /> },
                  { path: 'activity-log', element: <Outlet /> },
                ],
              },
            ],
          },
          { path: 'action-items', element: <Outlet /> },
          {
            path: 'tasks',
            element: <Outlet />,
            children: [
              { path: 'new', element: <Outlet /> },
              {
                path: ':taskId',
                element: <Outlet />,
                children: [
                  { path: 'edit', element: <Outlet /> },
                  { path: 'subtasks', element: <Outlet /> },
                  { path: 'subtasks/new', element: <Outlet /> },
                ],
              },
            ],
          },
        ],
      },
    ],
  },
  {
    path: paths.organizations.details.auditDetails,
    element: loadable(
      () => import('./pages/AuditDetailsPage/AuditDetailsPage')
    ),
    children: [
      {
        path: 'documents/attach',
        element: loadable(
          () =>
            import(
              './components/AuditDetails/AuditUploadDocuments/routes/AuditDocumentsAttachRoute'
            )
        ),
      },
      {
        path: 'spend-estimated/vendor-accounts/attach',
        element: loadable(
          () =>
            import(
              './components/AuditDetails/AuditSpendEstimated/VendorAccounts/routes/AuditVendorAccountsAttachRoute'
            )
        ),
      },
      {
        path: 'spend-estimated/vendor-accounts/new',
        element: loadable(
          () =>
            import(
              './components/AuditDetails/AuditSpendEstimated/VendorAccounts/routes/AuditVendorAccountsNewRoute'
            )
        ),
      },
      {
        path: 'spend-estimated/spends/new',
        element: loadable(
          () =>
            import(
              './components/AuditDetails/AuditSpendEstimated/routes/AuditSpendEstimatedSpendsNewRoute'
            )
        ),
      },
      {
        path: 'spend-estimated/spends/import',
        element: loadable(
          () =>
            import(
              './components/AuditDetails/AuditSpendEstimated/routes/AuditSpendEstimatedSpendsImportRoute'
            )
        ),
      },
      {
        path: 'negotiations/vendors/attach',
        element: loadable(
          () =>
            import(
              './components/AuditDetails/AuditNegotiations/routes/AuditNegotiationsVendorsAttachRoute'
            )
        ),
      },
      {
        path: 'negotiations/vendors/new',
        element: loadable(
          () =>
            import(
              './components/AuditDetails/AuditNegotiations/routes/AuditNegotiationsVendorsNewRoute'
            )
        ),
      },
    ],
  },
];
